import CityPage from '../../components/CityPage';

const cityData = {
    name: "Houlgate",
    slug: "houlgate",
    postalCode: "14510",
    intro: "Débarras professionnel à Houlgate avec CC Débarras 14. Située sur la Côte Fleurie entre Dives-sur-Mer et Villers-sur-Mer, Houlgate est une commune que nous desservons régulièrement. Nous intervenons pour toutes vos situations : succession, vente de bien, départ en maison de retraite ou déménagement. Appartements, maisons et caves : nous prenons tout en charge, rapidement et soigneusement.",
    nearby: ["Dives-sur-Mer", "Villers-sur-Mer", "Auberville", "Cabourg", "Blonville-sur-Mer"],
};

const Houlgate = () => <CityPage city={cityData} />;

export default Houlgate;
